var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TenantLogo",style:({ width: `${_vm.image.width}px` })},[_c('img',{style:(_vm.style),attrs:{"src":_vm.src,"width":_vm.image.width,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }